import React, { Component } from "react";
import { Modal } from "antd";
import styles from "./darkModal.module.less";
import DragM from "dragm";
import classnames from "classnames";
import { v4 as uuidv4 } from "uuid";
class BuildTitle extends React.Component {
  updateTransform = (transformStr) => {
    this.modalDom.style.transform = transformStr;
  };

  componentDidMount() {
    const { uuid } = this.props;
    let dom = document.getElementsByClassName(uuid);
    if (dom && dom.length > 0) {
      dom = document.getElementsByClassName(uuid)[0];
      this.modalDom = dom.parentNode;
    }
  }
  render() {
    const { title } = this.props;
    return (
      <DragM updateTransform={this.updateTransform}>
        <div>{title}</div>
      </DragM>
    );
  }
}

class DarkModal extends Modal {
  uuid = uuidv4();

  render() {
    const { className, visible } = this.props;
    let paProps = { ...this.props };
    delete paProps.className;
    let titleValue = <BuildTitle title={this.props.title} uuid={this.uuid} />;
    let ret = visible ? (
      <Modal
        destroyOnClose={true}
        className={classnames(this.uuid, styles.modalDiv, className)}
        {...paProps}
        title={titleValue}
      >
        {this.props.children}
      </Modal>
    ) : (
      ``
    );
    return ret;
  }
}
export default DarkModal;
